/**
 * User Category Constants
 *
 * ประเภทผู้ใช้งาน - สำหรับการจัดกลุ่มผู้ใช้และ Personalization
 */

export interface UserCategory {
  value: string;
  label: string;
  description: string;
  icon: string;
}

/**
 * USER_CATEGORIES - ประเภทผู้ใช้งานทั้งหมด
 *
 * ใช้งานใน:
 * - Registration form (ฟอร์มสมัครผู้ใช้)
 * - User profiling (จัดกลุ่มผู้ใช้)
 * - Personalized experience (ปรับแต่งประสบการณ์)
 */
export const USER_CATEGORIES: UserCategory[] = [
  {
    value: 'security_company',
    label: 'บริษัทรักษาความปลอดภัย',
    description: 'ผู้ให้บริการบริษัทรักษาความปลอดภัย',
    icon: '🛡️'
  },
  {
    value: 'juristic_management',
    label: 'บริษัทบริหารนิติบุคคล',
    description: 'บริษัทบริหารนิติบุคคล / จัดการอาคาร',
    icon: '🏢'
  },
  {
    value: 'juristic_person',
    label: 'นิติบุคคล / อาคารชุด',
    description: 'กรรมการนิติฯ / ผู้จัดการนิติฯ',
    icon: '🏘️'
  },
  {
    value: 'corporate',
    label: 'องค์กร / บริษัททั่วไป',
    description: 'โรงงาน, ร้านค้า, สำนักงาน',
    icon: '🏭'
  },
  {
    value: 'individual',
    label: 'บุคคลทั่วไป',
    description: 'ผู้ใช้ทั่วไปที่ต้องการค้นหาบริการ',
    icon: '👤'
  },
  {
    value: 'event_organizer',
    label: 'ผู้จัด Event / งานอีเว้นท์',
    description: 'ผู้จัดงาน Event ต้องการรักษาความปลอดภัยงานอีเว้นท์',
    icon: '🎪'
  },
  {
    value: 'consultant',
    label: 'ที่ปรึกษา / ผู้ให้คำปรึกษา',
    description: 'ผู้เชี่ยวชาญด้านความปลอดภัยและความมั่นคง',
    icon: '💼'
  },
  {
    value: 'researcher',
    label: 'นักวิจัย / นักศึกษา',
    description: 'ผู้ค้นคว้าด้านความปลอดภัยและความมั่นคง',
    icon: '🎓'
  },
  {
    value: 'other',
    label: 'อื่นๆ',
    description: 'ไม่อยู่ในกลุ่มใดกลุ่มหนึ่ง',
    icon: '❓'
  }
];

/**
 * Helper function to get category by value
 */
export const getCategoryByValue = (value: string): UserCategory | undefined => {
  return USER_CATEGORIES.find(cat => cat.value === value);
};

/**
 * Helper function to get category label
 */
export const getUserCategoryLabel = (value: string): string => {
  const category = getCategoryByValue(value);
  return category ? category.label : value;
};

/**
 * Helper function to get category icon
 */
export const getUserCategoryIcon = (value: string): string => {
  const category = getCategoryByValue(value);
  return category ? category.icon : '❓';
};

/**
 * Validation helper
 */
export const isValidUserCategory = (value: string): boolean => {
  return USER_CATEGORIES.some(cat => cat.value === value);
};
